import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import userStore from "./app/redux/UserStore";
import 'bootstrap/dist/js/bootstrap.js';
import './styles/CourierPrimeFont.css';
import './styles/FiraSansFont.css';
import 'antd/dist/antd.css';
import App from './App';
import './index.css';
// Bug 44720 - Outdated Jquery Scripts in CQ/PP: keeps window.$/window.jQuery available for injected epub/CQ/PP markup now that the CDN jQuery 1.8.3 tag is disabled in public/index.html
window.$ = window.jQuery = $;
ReactDOM.render(
    <Provider store={userStore}>
        <BrowserRouter basename="/cc">
            <App />
        </BrowserRouter >
    </Provider>,
    document.getElementById('root')
);
serviceWorkerRegistration.register();